
export const CORE_API_ENDPOINT = '/core'
export const O365_API_ENDPOINT = '/o365'

// export const CORE_API_ENDPOINT = 'https://frontgg.bainisysstg.com/core'
// export const O365_API_ENDPOINT = 'https://frontgg.bainisysstg.com/o365'

// export const CORE_API_ENDPOINT = 'https://front25ex2013.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://front25ex2013.rmbainisys.com/o365'

// export const CORE_API_ENDPOINT = 'https://front25o365.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://front25o365.rmbainisys.com/o365'

// export const CORE_API_ENDPOINT = 'https://front25gg.rmbainisys.com/core'
// export const O365_API_ENDPOINT = 'https://front25gg.rmbainisys.com/o365'

// export const CORE_API_ENDPOINT = 'http://localhost:2800/core'
// export const O365_API_ENDPOINT = 'http://localhost:3100/o365'

// export const CORE_API_ENDPOINT = 'http://bs-local.com:2800/core'
// export const O365_API_ENDPOINT = 'http://bs-local.com:3100/o365'

// roomminister, central, meetup
export const THEMES = "roomminister"

export const SHOW_EVENT_TYPE = true
export const SHOW_ROOM_FORMAT = true
export const SHOW_EVENT_REPEAT = true


// WEBPACK FOOTER //
// ./src/lib/api.js